<div class="p-grid">
  <div class="p-col-2">
    <div *ngFor="let m of adminMenus" class="back">
      <app-menu-button [menu]="m"></app-menu-button>
    </div>
  </div>
  <div class="p-col-10">
    <app-menu-screen [menus]="menus"></app-menu-screen>
  </div>
</div>
